import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {withStyles} from '@material-ui/core';
import BaseComponent from "./BaseComponent";

const ErrorMessage = ({classes, className, ...rest}) => (
    <BaseComponent className={cn(classes.errorMessage, className, 'errorMessage')} {...rest}/>);

ErrorMessage.propTyes = {
    text: PropTypes.string,
    as: PropTypes.string,
};

ErrorMessage.defaultProps = {
    as: 'p',
};

export default withStyles(() => ({
    errorMessage: {
        padding: 10,
        color: '#fafafa',
        backgroundColor: '#f44336',
    }
}))(ErrorMessage);
